export default function Banner(props) {
    const id = props.id || "banner";
    const payment_mode = props.payment_mode || "payment";
    let title, body;

    if (payment_mode === "subscription") {
      title = "Want to try before you buy? "
      body = "Pay as you go with $1 per credit"
    }
    else if (payment_mode === "payment") {
      title = "Want unlimited access? "
      body = "Switch to premium for only $7/week"
    }
    else if (payment_mode === "weekly-subscription") {
      title = "Want a better deal? "
      body = "Switch to monthly subscription for $15/month"
    }
    return (
      <label id={id} onClick={props.handler} className={`cursor-pointer flex flex-row ${props.margin_top ? 'mt-7' : ''} ${props.margin_all ? 'mx-10 mt-12' : 'w-full'}`}>
      <span className="w-full text-md relative inline-block p-2  font-semibold text-stone-900 leading-tight">
          <span aria-hidden className="absolute inset-0 bg-rainbowdark dark:bg-rainbow opacity-50 rounded-lg"></span>                        
          <span className="relative flex flex-row">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="align-middle mt-0.5 mr-1 shrink-0"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"/></svg>            <span>{title}<span className='md:ml-1 text-sm link font-normal'>{body}</span></span></span>
          </span>                    
    </label>
    )
}